import { AssetType } from 'common/api/models';
import UploadingEntry from 'redux/fileUpload/interfaces/uploadingEntry';
import { createEntry } from 'redux/fileUpload/utils/createEntry';

const createEntries = (files: File[], typeId: AssetType): UploadingEntry[] =>
  files.map((file) => createEntry(file, typeId));

export default createEntries;
